// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-wrapper {
  width: 100%;
  border-top: 1px solid #777777;
}

.footer {
  display: flex;
  flex-direction: column;
  gap: 84px;
  padding: 84px 67px;
  max-width: 1512px;
  margin: 0 auto;
  background-color: #ffffff;
}

.footer-content {
  display: flex;
  gap: 67px;
  width: 100%;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 34px;
  flex: 1 1;
}

.footer-logo {
  height: 85px;
  width: 145px;
}

.footer-info {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.footer-label {
  font-weight: 600;
  font-size: 15px;
}

.footer-contact a,
.footer-links-column a,
.footer-links-secondary a {
  color: black;
  text-decoration: none;
  font-size: 15px;
  line-height: 22px;
}

.social-links {
  display: flex;
  gap: 10px;
}

.footer-links-column {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.footer-links-column a {
  font-weight: 600;
  font-size: 17px;
}

.footer-credits {
  display: flex;
  flex-direction: column;
  gap: 34px;
}

.divider {
  height: 1px;
  background-color: #777777;
}

.credits-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.credits-text {
  font-size: 15px;
}

.footer-links-secondary {
  display: flex;
  gap: 25px;
}

@media (max-width: 1224px) {
  .footer {
    padding: 55px 23px;
    gap: 55px;
  }

  .footer-content {
    flex-direction: column;
    gap: 55px;
  }

  .footer-column,
  .footer-links-column {
    width: 100%;
  }

  .credits-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 37px;
  }

  .footer-links-secondary {
    flex-direction: column;
    gap: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".footer-wrapper {\n  width: 100%;\n  border-top: 1px solid #777777;\n}\n\n.footer {\n  display: flex;\n  flex-direction: column;\n  gap: 84px;\n  padding: 84px 67px;\n  max-width: 1512px;\n  margin: 0 auto;\n  background-color: #ffffff;\n}\n\n.footer-content {\n  display: flex;\n  gap: 67px;\n  width: 100%;\n}\n\n.footer-column {\n  display: flex;\n  flex-direction: column;\n  gap: 34px;\n  flex: 1;\n}\n\n.footer-logo {\n  height: 85px;\n  width: 145px;\n}\n\n.footer-info {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.footer-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.footer-label {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.footer-contact a,\n.footer-links-column a,\n.footer-links-secondary a {\n  color: black;\n  text-decoration: none;\n  font-size: 15px;\n  line-height: 22px;\n}\n\n.social-links {\n  display: flex;\n  gap: 10px;\n}\n\n.footer-links-column {\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n}\n\n.footer-links-column a {\n  font-weight: 600;\n  font-size: 17px;\n}\n\n.footer-credits {\n  display: flex;\n  flex-direction: column;\n  gap: 34px;\n}\n\n.divider {\n  height: 1px;\n  background-color: #777777;\n}\n\n.credits-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.credits-text {\n  font-size: 15px;\n}\n\n.footer-links-secondary {\n  display: flex;\n  gap: 25px;\n}\n\n@media (max-width: 1224px) {\n  .footer {\n    padding: 55px 23px;\n    gap: 55px;\n  }\n\n  .footer-content {\n    flex-direction: column;\n    gap: 55px;\n  }\n\n  .footer-column,\n  .footer-links-column {\n    width: 100%;\n  }\n\n  .credits-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 37px;\n  }\n\n  .footer-links-secondary {\n    flex-direction: column;\n    gap: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
